import React from "react";
import { Alert, Button, Card, Col, Descriptions, Form, Input, Modal, Row, Select, Tabs } from "antd";
import useModalEvaluacion from "../../hooks/useModalEvaluacion";
import PreguntasPuntualidad from "./PreguntasPuntualidad";
import useModalEvaluacionConductor from "../../hooks/useModalEvaluacionConductor";
import PreguntasComunicacionReportes from "./PreguntasComunicacionReportes";
import PreguntasResponsabilidadManejoVehiculo from "./PreguntasResponsabilidadManejoVehiculo";
import PreguntasActitudTrabajoEquipo from "./PreguntasActitudTrabajoEquipo";
import PreguntasImagenRepresentacionEmpresa from "./PreguntasImagenRepresentacionEmpresa";
import PreguntasPredisposicion from "./PreguntasPredisposicion";
import FactoresEvaluacion from "./FactoresEvaluacion";
import FactoresEvaluacionConductor from "./FactoresEvaluacionConductor";
import ObservacionResultado from "./ObservacionResultado";
import ResultadoEvaluacion from "./ResultadoEvaluacion";
import PlanAccionConductor from "./PlanAccionConductor";
import Renovacion from "./Renovacion";
import PreguntasConocimientosTecnicos from "./PreguntasConocimientosTecnicos";
import useModalEvaluacionMecanico from "../../hooks/useModalEvaluacionMecanico";
import PreguntasCalidadTrabajo from "./PreguntasCalidadTrabajo";
import PreguntasProductividadEficiencia from "./PreguntasProductividadEficiencia";
import PreguntasResponsabilidadPuntualidad from "./PreguntasResponsabilidadPuntualidad";
import PreguntasTrabajoEquipoActitud from "./PreguntasTrabajoEquipoActitud";
import PreguntasResolucionProblemaTomaDecisiones from "./PreguntasResolucionProblemaTomaDecisiones";
import FactoresEvaluacionMecanico from "./FactoresEvaluacionMecanico";
import PlanAccionMecanico from "./PlanAccionmecanico";
import ResultadoEvaluacionMecanico from "./ResultadoEvaluacionMecanico";

const ModalEvaluacionMecanico = () => {
	const { visibleModalEvaluacionMecanico, onClickBtnEnviar, ocultarModal } = useModalEvaluacionMecanico();

	return (
		<Modal
			title="FICHA DE EVALUACIÓN DE DESEMPEÑO LABORAL"
			open={visibleModalEvaluacionMecanico}
			onCancel={ocultarModal}
			onOk={onClickBtnEnviar}
			okText="Evaluar"
			destroyOnClose={true}
			width={800}
		>
			<PreguntasConocimientosTecnicos />
			<PreguntasCalidadTrabajo />
			<PreguntasProductividadEficiencia />
			<PreguntasResponsabilidadPuntualidad />
			<PreguntasTrabajoEquipoActitud />
			<PreguntasResolucionProblemaTomaDecisiones />
			<FactoresEvaluacionMecanico />
			<ObservacionResultado/>
			<ResultadoEvaluacionMecanico />
			<PlanAccionMecanico />
			<Renovacion /> 
		</Modal>
	);
};

export default ModalEvaluacionMecanico;
